function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
var Logo = function(_param) {
    var isDark = _param.isDark, props = _objectWithoutProperties(_param, [
        "isDark"
    ]);
    var textColor = isDark ? "#FFFFFF" : "#000000";
    return /*#__PURE__*/ _jsx("span", {
        children: /*#__PURE__*/ _jsxs("picture", {
            children: [
                /*#__PURE__*/ _jsx("source", {
                    type: "image/png",
                    srcSet: "images/apidaeSwap.png, images/home/cake/coin.webp"
                }),
                /*#__PURE__*/ _jsx("img", {
                    src: "images/apidaeSwap.png",
                    loading: "lazy",
                    decoding: "async",
                    width: 198
                })
            ]
        })
    });
};
export default /*#__PURE__*/ React.memo(Logo, function(prev, next) {
    return prev.isDark === next.isDark;
});
